import { useAuth } from '../hooks/useAuth';
import { useSocial } from '../hooks/useSocial';
import UserMenu from './UserMenu';

const NAV_TABS = [
  { key: 'dashboard', label: 'Home' },
  { key: 'series', label: 'Collection', group: ['series', 'sets', 'cards'] },
  { key: 'pokedex', label: 'Pokédex' },
  { key: 'wishlist', label: 'Wishlist' },
  { key: 'trades', label: 'Trades' },
  { key: 'friends', label: 'Friends' },
];

const initials = (username) => (username ? username.slice(0, 2).toUpperCase() : '?');

const Header = ({ currentView, onNavigate }) => {
  const { user } = useAuth();
  const { incoming, matches } = useSocial();

  // Data-driven badge counts: pending friend requests + friends with matches
  const badgeCounts = {
    friends: incoming.length,
    trades: matches.filter((m) => m.score > 0).length
  };

  return (
    <div className="hidden md:flex items-center justify-between h-[58px] px-10 bg-navy-deeper border-b border-white/[0.07]">
      <div className="flex items-center gap-2.5">
        <img src="/pockedex_logo.png" alt="Pockedex" className="w-8 h-8 rounded-lg" />
        <span className="font-heading font-extrabold text-yellow text-xl">Pockedex</span>
      </div>

      <nav className="flex items-center gap-1">
        {NAV_TABS.map((tab) => {
          const isActive = tab.group ? tab.group.includes(currentView) : currentView === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => onNavigate(tab.key)}
              className={`relative px-4 py-1.5 rounded-full text-[13px] font-medium transition-colors ${
                isActive ? 'bg-yellow text-navy-dark' : 'text-white/60 hover:bg-white/10 hover:text-white'
              }`}
            >
              {tab.label}
              {badgeCounts[tab.key] > 0 && (
                <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full bg-brick text-white text-[10px] font-bold flex items-center justify-center">
                  {badgeCounts[tab.key]}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-yellow to-brick flex items-center justify-center text-navy-dark text-xs font-bold">
          {initials(user?.username)}
        </div>
        <UserMenu />
      </div>
    </div>
  );
};

export default Header;
